import {
  RESET_HN_FORM_DATA,
  SET_HN_FORM_DATA,
  SET_HN_LIST,
  PROJECTS_LIST_HN,
  SET_SLOT_DEDICATED_DATA_HN,
  SET_PROJECT_ID_HN,
  SET_SELLERS_LIST_HN,
  SET_FAS_CITIES_HN,
  SET_FSL_CITIES_HN,
  HN_HOUSING_LOCALITY,
  RESET_HN_HOUSING_LOCALITY,
} from "../actions/housingNeo.actions";

const defaultState = {};
const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_HN_FORM_DATA: {
      const { section, data } = action.payload;
      return {
        ...state,
        housingNeo: {
          ...(state.housingNeo || {}),
          formData: {
            ...(state.housingNeo?.formData || {}),
            [section]: data,
          },
        },
      };
    }
    case RESET_HN_FORM_DATA: {
      return {
        ...state,
        housingNeo: {
          ...state.housingNeo,
          formData: {},
          editDataLoaded: false,
        },
      };
    }
    case SET_HN_LIST: {
      return {
        ...state,
        housingNeo: {
          ...state.housingNeo,
          list: action.payload.results || [],
          totalPages:
            action.payload.totalPages + (action.payload.hasNextPage ? 1 : 0),
        },
      };
    }
    case PROJECTS_LIST_HN: {
      return {
        ...state,
        housingNeo: {
          ...state.housingNeo,
          projects: action.payload || [],
        },
      };
    }
    case SET_PROJECT_ID_HN: {
      return {
        ...state,
        housingNeo: {
          ...state.housingNeo,
          projectMap: action.payload,
        },
      };
    }
    case SET_SELLERS_LIST_HN: {
      return {
        ...state,
        housingNeo: {
          ...state.housingNeo,
          sellerList: action.payload.sellerList,
          projectRegion: action.payload.projectRegion,
        },
      };
    }
    case SET_SLOT_DEDICATED_DATA_HN: {
      return {
        ...state,
        housingNeo: {
          ...state.housingNeo,
          formData: {
            ...action.payload,
          },
          editDataLoaded: true,
        },
      };
    }
    case SET_FAS_CITIES_HN: {
      return {
        ...state,
        housingNeo: {
          ...state.housingNeo,
          fasCities: action.payload,
        },
      };
    }
    case SET_FSL_CITIES_HN: {
      return {
        ...state,
        housingNeo: {
          ...state.housingNeo,
          fslCities: action.payload,
        },
      };
    }
    case HN_HOUSING_LOCALITY: {
      return {
        ...state,
        housingNeo: {
          ...state.housingNeo,
          housingLocality: action.payload,
        },
      };
    }
    case RESET_HN_HOUSING_LOCALITY: {
      return {
        ...state,
        housingNeo: {
          ...state.housingNeo,
          housingLocality: [],
        },
      };
    }
  }
};

export default reducer;
